// Central place for runtime config. Backend URL comes from CRA env at build time.
export const BACKEND_URL =
  process.env.REACT_APP_BACKEND_URL || 'http://localhost:8080';

export const API_BASE = `${BACKEND_URL}/api/v1`;

// Guest login only exists on local backends (ENVIRONMENT=local). Used to hide
// the dev-only "Continue as guest" button in deployed environments.
export const IS_LOCAL = /localhost|127\.0\.0\.1/.test(BACKEND_URL);
